import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { PageLoader } from '../common';

const ProtectedRoute = ({ children, roles }) => {
  const { user, initialized } = useAuth();

  // Wait for the initial token-check before making any redirect decision.
  // Without this, a logged-in user with a slow server would be flashed to /login.
  if (!initialized) {
    return <PageLoader />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
